import { isBmSpecialMarket } from "@hypexone/uicore";

export const normalizeInput = (str) => {
  if (!str) {
    return null
  }
  return str.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
}

export interface CurrencyListDto {
  crypto_currency: string;
  blockchain: string;
  network_id: string;
  token_type: string;
  token_address: string;
}

export const USERNAME_REGEX =
  /^(?!.*(?:\\d[-.\\s]*){9})([a-zA-Z0-9][a-zA-Z0-9_@-]*)$/i;

export const getRootDomain = () => {
  let hostname = window.location.hostname.replace(/www./g, '');
  const parts = hostname.split('.');

  // If it's an IP or localhost, return as is
  if (parts.length <= 2) return hostname;

  // Regex pattern to detect compound TLDs (more comprehensive)
  // Matches patterns like: co.xx, com.xx, org.xx, net.xx, edu.xx, gov.xx, ac.xx, etc.
  const compoundTLDPattern =
    /\.(co|com|org|net|edu|gov|ac|ne|or|gr|go)\.[a-z]{2,3}$/i;

  if (compoundTLDPattern.test(hostname)) {
    // For compound TLDs, return the last 3 parts (domain.compound.tld)
    return parts.slice(-3).join('.');
  }

  // Check for other multi-part patterns (like .k12.xx.us or .pvt.k12.xx.us)
  if (parts.length >= 4 && /^(k12|pvt)$/i.test(parts[parts.length - 3])) {
    return parts.slice(-4).join('.');
  }

  // Default case: return last 2 parts for standard TLDs
  return parts.slice(-2).join('.');
};

export const oddValueFormatter = (marketType, oddValue, sessionRuns, marketName, oddType) => {
  if (oddValue === -1) {
    return '-';
  }

  let res = '-';
  switch (marketType) {
    case 'BOOKMAKER':
    case 1:
      res = isBmSpecialMarket(marketName, oddType) ? Number(oddValue).toFixed(2) : Number(oddValue * 100 - 100).toFixed(2);
      break;
    case 'FANCY':
    case 2: // fancy
      res = Number(sessionRuns).toFixed(2);
      break;
    case 'BINARY':
    case 5: // binary
      res = Number(sessionRuns).toFixed(2);
      break;
    default:
      res = Number(oddValue).toFixed(2);
  }

  return res;
};